export const ASSET_URL = "assetUrl";
export const ASSET_URL_OP_FILE = "file";
export const DESIGN_CONTEXT = "designContext";
export const PREVIEW_URL_OP_FILE = "preview";

export default {
  ASSET_URL,
  ASSET_URL_OP_FILE,
  DESIGN_CONTEXT,
  PREVIEW_URL_OP_FILE,
};
